function getConfiguredApiBaseUrl() {
  const runtimeValue = window.__DATASCOPE_CONFIG__?.apiBaseUrl?.trim();
  const buildValue = process.env.REACT_APP_API_BASE_URL?.trim();
  const rawValue = runtimeValue || buildValue || "";

  if (!rawValue) {
    return "";
  }

  return rawValue.replace(/\/+$/, "");
}

function resolveApiUrl(url, apiBaseUrl) {
  if (!apiBaseUrl) {
    return url;
  }

  if (typeof url === "string") {
    if (url.startsWith("/api/")) {
      return `${apiBaseUrl}${url}`;
    }

    return url;
  }

  if (url instanceof Request) {
    const requestUrl = new URL(url.url, window.location.origin);
    const isSameOrigin = requestUrl.origin === window.location.origin;

    if (isSameOrigin && requestUrl.pathname.startsWith("/api/")) {
      return `${apiBaseUrl}${requestUrl.pathname}${requestUrl.search}`;
    }
  }

  return url;
}

export function installApiBaseUrlSupport() {
  const apiBaseUrl = getConfiguredApiBaseUrl();

  if (!apiBaseUrl || window.__DATASCOPE_API_BASE_INSTALLED__) {
    return;
  }

  const originalFetch = window.fetch.bind(window);

  window.fetch = (input, init) => {
    const rewrittenInput = resolveApiUrl(input, apiBaseUrl);

    if (input instanceof Request && typeof rewrittenInput === "string") {
      return originalFetch(new Request(rewrittenInput, input), init);
    }

    return originalFetch(rewrittenInput, init);
  };

  window.__DATASCOPE_API_BASE_INSTALLED__ = true;
}
